import React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Toolbar, IconButton, Tooltip, Typography } from '@material-ui/core';
import { ArrowLeft } from 'react-feather';
import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
    },
    header: {
      flex: 1,
      color: theme.palette.coolGrey[50],
      fontSize: '1.5rem',
      fontWeight: theme.typography.fontWeightBold,
      textAlign: 'center',
    },
    backButton: {
      flex: 0,
      color: theme.palette.primary.contrastText,
      '&:hover, &:focus': {
        background: theme.palette.primary.main,
      },
    },
  });
});

export interface ChannelConfigurationHeaderProps {
  handleBack: () => void;
}
const ChannelConfigurationHeader = ({
  handleBack,
}: ChannelConfigurationHeaderProps) => {
  const classes = useStyles();

  return (
    <Toolbar className={classes.root}>
      <Tooltip title="Back" enterDelay={500} placement="top">
        <IconButton
          onClick={handleBack}
          aria-label="Back"
          className={classes.backButton}
        >
          <ArrowLeft />
        </IconButton>
      </Tooltip>

      <Typography className={classes.header} variant="h6" color="inherit">
        Channel Configuration
      </Typography>
    </Toolbar>
  );
};

export default ChannelConfigurationHeader;
